import React, {Dispatch, SetStateAction, useState} from 'react';
import s from './CategorySelector.module.css';
import CategorySelectorSvg from './CategorySelectorSVG';
import {SubcategoryType} from '../../types/ProductSliceTypes';
import {FormikValues, useFormikContext} from 'formik';

interface Props {
	title: string;
	subcategories: SubcategoryType[];
	handleChange: (catId: number) => void;
	field: string; //field name in formik
	isOpen?: boolean;
	onToggle?: () => void;
	scrollToList?: () => void;
	setOpenCategoryId: Dispatch<SetStateAction<string | null>>;
}

const CategorySelector: React.FC<Props> = ({
	title,
	subcategories,
	field,
	handleChange,
	isOpen,
	onToggle,
	scrollToList,
	setOpenCategoryId,
}) => {
	const {values, setFieldValue} = useFormikContext<FormikValues>();
	const [openSub, setOpenSub] = useState<string | null>(null);

	const handleClickCategory = (id: string, last: boolean) => {
		setFieldValue(field, id);
		handleChange(+id);
		setOpenSub((prev) => (id === prev ? null : id));
		if (last && field) {
			setOpenCategoryId(null);
			scrollToList && scrollToList();
		}
		/*if (last && field) {
			setFieldValue(field, id);
			handleChange(+id);
		} else if (!last) {
			setOpenSub((prev) => (id === prev ? null : id));
		}*/
	};
	return (
		<div className={s.sideList}>
			<div className={s.sideItem}>
				<div className={s.sideItemGreenTitle}>
					<div className={s.greenElement}>
						<CategorySelectorSvg id="greenElement" />
					</div>
					<button
						type={'button'}
						className={s.sideItemTitle}
						onClick={onToggle}
					>
						<CategorySelectorSvg id="menuElement" />
						<span>{title}</span>

						<div
							className={s.menuArrow}
							style={{
								transition: '300ms',
								transform: isOpen ? 'rotate(180deg)' : '',
							}}
						>
							{subcategories?.length > 0 && (
								<CategorySelectorSvg id="menuArrow" />
							)}
						</div>
					</button>
				</div>
				{isOpen && subcategories?.length > 0 && (
					<ul className={s.sideSubList}>
						{subcategories.map((sub) => (
							<li key={sub.category_id} className={s.sideSubItem}>
								<button
									type={'button'}
									onClick={() => {
										handleClickCategory(
											sub.category_id,
											sub.subcategories2 === null,
										);
									}}
									className={`${s.sideSubItemTitle} ${sub.category_id === values[field] ? s.active : ''}`}
								>
									<span className={s.subItemTitle}>{sub.name}</span>
									{sub.subcategories2?.length > 0 && (
										<span>
											<CategorySelectorSvg id="menuArrow" />
										</span>
									)}
								</button>

								{openSub === sub.category_id &&
									sub.subcategories2?.length > 0 && (
										<ul className={s.sideSubSubList}>
											{sub.subcategories2.map((sub2) => (
												<li
													key={sub2.category_id}
													className={`${s.sideSubItem} ${sub2.category_id === values[field] ? s.active : ''}`}
												>
													<button
														type={'button'}
														onClick={() =>
															handleClickCategory(sub2.category_id, true)
														}
													>
														{sub2.name}
													</button>
												</li>
											))}
										</ul>
									)}
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	);
};

export default CategorySelector;
